import { render, staticRenderFns } from "./addtshare.vue?vue&type=template&id=5fab7616&"
import script from "./js/addtshare.js?vue&type=script&lang=js&"
export * from "./js/addtshare.js?vue&type=script&lang=js&"
import style0 from "./addtshare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports